module.exports = __webpack_public_path__ + "static/media/arrow_up.2c40d518.svg";